import {mapActions, mapGetters, mapMutations} from 'vuex'
import ImageFile from '@/components/image-file/index.vue'
import validationMixin from '@/mixins/validation'
import {mask} from 'vue-the-mask'
import moment from "moment";

const {Entropy} = require('entropy-string')

export default {
	name: 'user-student-create',
	mixins: [validationMixin],
	directives: {mask},
	data() {
		return {
			payload: {
				birthday: moment().subtract(20, 'year').toISOString().substr(0, 10),
				activity: '',
				gender: '',
				fullName: '',
				fullNameEn: '',
				email: '',
				typeId: 0,
				originCountry: '',
				defaultCountry: '',
				coursesLanguages: '',
				isAuthor: false,
				isSpeaker: false,
				password: '',
				confirmPassword: '',
				employers: '',
				interface: '',
				isActive: false,
				sendToEmail: false,
				courses: [],
				file: '',
				isTester: false
			},
			showPassword: false,
			valid: false,
			openDatepicker: false,
			validationErrors: {}
		}
	},
	components: {
		ImageFile
	},
	computed: {
		...mapGetters({
			profile: 'profile/profile',
			countries: 'setting/countries',
			interfaceLanguages: 'setting/interfaceLanguages',
			coursesList: 'setting/coursesList',
			isLoading: 'userStudents/isLoading',
			basicCountries: 'setting/basicCountries',
			userTypes: 'userSetting/userTypes',
		}),
		employers() {
			return [
				{
					name: '0',
					value: '0'
				},
				{
					name: '1-5',
					value: '1-5'
				},
				{
					name: '5-20',
					value: '5-20'
				},
				{
					name: '20-100',
					value: '20-100'
				},
				{
					name: '100+',
					value: '100+'
				}
			]
		},
		genders() {
			return [
				{
					name: this.$t('male'),
					value: 'male'
				},
				{
					name: this.$t('female'),
					value: 'female'
				}
			]
		},
		items() {
			return [
				{
					name: this.$t('student'),
					value: 'student'
				},
				{
					name: this.$t('businessman'),
					value: 'businessman'
				},
				{
					name: this.$t('employee'),
					value: 'employee'
				},
				{
					name: this.$t('freelancer'),
					value: 'freelancer'
				},
				{
					name: this.$t('another'),
					value: 'another'
				}
			]
		},
		computedDateFormatted() {
			return this.formatDate(this.payload.birthday)
		},
		defaultCountries() {
			if (this.profile) {
				const list = this.profile.countries.data.filter(e => e.type === 'access')
				return list.map(e => e.country.data)
			}
			return []
		},
		interfaceLanguagesNames() {
			if (!!this.interfaceLanguages && this.interfaceLanguages.length) return this.interfaceLanguages.map(item => ({
				...item,
				name: item.locale
			}))
		}
	},
	created() {
		if (!this.countries) {
			this.fetchCountries()
		}
		if (!this.userTypes) {
			this.fetchUsersSetting()
		}
	},
	methods: {
		...mapActions({
			fetchCountries: 'setting/GET_COUNTRIES_LIST',
			fetchInterface: 'setting/GET_LANGUAGE_INTERFACE_LIST',
			create: 'userStudents/CREATE_USER',
			fetchUsersSetting: 'userSetting/GET_USERS_SETTING'
		}),
		...mapMutations({}),
		formatDate(date) {
			if (!date) return null

			const [year, month, day] = date.split('-')
			return `${day}.${month}.${year}`
		},
		generateRandomPassword() {
			const entropy = new Entropy({
				total: 1e6,
				risk: 1e9
			})
			const string = entropy.string()
			this.payload.password = string
			this.payload.confirmPassword = string
			this.payload.sendToEmail = true
		},
		createRequestPayload() {
			const data = new FormData();
			
			data.append('full_name', this.payload.fullName)
			data.append('full_name_en', this.payload.fullNameEn)
			data.append('email', this.payload.email)
			data.append('phone', this.payload.phone)
			data.append('type_id', this.payload.typeId)
			data.append('origin_country_id', this.payload.originCountry)
			data.append('default_country_id', this.payload.defaultCountry)
			data.append('courses_languages', Array.isArray(this.payload.coursesLanguages) ? this.payload.coursesLanguages.join(',') : '')
			data.append('password', this.payload.password)
			data.append('password_confirmation', this.payload.confirmPassword)
			data.append('is_author', this.payload.isAuthor ? '1' : '0')
			data.append('is_speaker', this.payload.isSpeaker ? '1' : '0')
			data.append('active', this.payload.isActive ? '1' : '0')
			data.append('avatar', this.payload.file)
			data.append('gender', this.payload.gender)
			data.append('birthday', this.payload.birthday)
			data.append('interface_language', this.payload.interface)
			data.append('send_password', this.payload.sendToEmail ? 1 : 0)
			data.append('activity[type]', this.payload.activity)
			data.append('activity[employees_count]', this.payload.employers)
			data.append('is_tester', this.payload.isTester ? '1' : '0')
			
			return data
		},
		submit() {
			this.$refs.form.validate()
			if (this.valid) {
				this.create(this.createRequestPayload())
				.then(response => {
					try {
						this.$router.push({name: 'user.students.personal-data', params: {id: response.id}})
					} catch (e) {
						console.log(e)
					}
					
					this.$toasted.success(this.$t('userSuccessCreate'))
				}).catch(error => {
					const errors = error.response.data.validation;
					
					for (const i in errors) {
						errors[i].forEach(e => {
							this.$toasted.error(e)
						})
					}
				})
			}
		},
		changeDefaultCountriesValue() {
			this.fetchInterface({id: this.payload.defaultCountry})
		}
	}
}
